const pad = (value) => String(value).padStart(2, '0');

export const COMPANY_TASK_CATEGORIES = [
  'Vergi',
  'Fatura',
  'Personel',
  'Kira',
  'Banka',
  'Resmi Islem',
  'Muhasebe',
  'Operasyon',
  'Diger'
];

export const COMPANY_TASK_STATUSES = [
  { value: 'all', label: 'Tum Durumlar' },
  { value: 'pending', label: 'Bekleyenler' },
  { value: 'overdue', label: 'Gecikenler' },
  { value: 'completed', label: 'Tamamlananlar' },
  { value: 'skipped', label: 'Atlananlar' }
];

export const COMPANY_TASK_CURRENCIES = ['TRY', 'USD', 'EUR', 'GBP'];

export const getCurrentMonthInputValue = (date = new Date()) => {
  const current = date instanceof Date ? date : new Date(date);
  return `${current.getFullYear()}-${pad(current.getMonth() + 1)}`;
};

export const getDefaultTaskDueDate = (monthKey) => {
  const safeMonth = monthKey || getCurrentMonthInputValue();
  return `${safeMonth}-05`;
};

export const formatTaskMonth = (monthKey) => {
  if (!monthKey) {
    return '-';
  }

  const [year, month] = monthKey.split('-').map(Number);
  const date = new Date(year, month - 1, 1);

  return new Intl.DateTimeFormat('tr-TR', {
    month: 'long',
    year: 'numeric'
  }).format(date);
};

export const formatTaskMonthShort = (monthKey) => {
  if (!monthKey) {
    return '-';
  }

  const [year, month] = monthKey.split('-').map(Number);
  const date = new Date(year, month - 1, 1);

  return new Intl.DateTimeFormat('tr-TR', {
    month: 'short',
    year: '2-digit'
  }).format(date);
};

export const formatTaskDate = (dateString) => {
  if (!dateString) {
    return '-';
  }

  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);

  return new Intl.DateTimeFormat('tr-TR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }).format(date);
};

export const formatTaskAmount = (amount, currency = 'TRY') => new Intl.NumberFormat('tr-TR', {
  style: 'currency',
  currency,
  maximumFractionDigits: 2
}).format(Number(amount || 0));

export const getCompanyTaskStatusMeta = (status) => {
  const statusMap = {
    pending: {
      label: 'Bekliyor',
      className: 'bg-amber-500/10 text-amber-300 border-amber-500/20'
    },
    overdue: {
      label: 'Gecikti',
      className: 'bg-red-500/10 text-red-300 border-red-500/20'
    },
    completed: {
      label: 'Tamamlandi',
      className: 'bg-emerald-500/10 text-emerald-300 border-emerald-500/20'
    },
    skipped: {
      label: 'Atlandi',
      className: 'bg-slate-500/10 text-slate-300 border-slate-500/20'
    }
  };

  return statusMap[status] || statusMap.pending;
};

export const mergeCategoryOptions = (categories = []) => Array.from(
  new Set([...COMPANY_TASK_CATEGORIES, ...categories.filter(Boolean)])
).sort((left, right) => left.localeCompare(right, 'tr'));

export const buildCurrencyBreakdown = (items, field) => {
  const grouped = items.reduce((accumulator, item) => {
    const currency = item.currency || 'TRY';
    accumulator[currency] = (accumulator[currency] || 0) + Number(item[field] || 0);
    return accumulator;
  }, {});

  return Object.entries(grouped)
    .filter(([, amount]) => amount > 0)
    .map(([currency, amount]) => `${formatTaskAmount(amount, currency)}`)
    .join(' • ');
};

export const formatCurrencyMapBreakdown = (currencyMap = {}) => Object.entries(currencyMap)
  .filter(([, amount]) => Number(amount || 0) > 0)
  .map(([currency, amount]) => formatTaskAmount(amount, currency))
  .join(' • ');

export const COMPANY_TASK_PERIODS = [
  { value: 'monthly', label: 'Her Ay' },
  { value: 'quarterly', label: '3 Ayda Bir (Çeyreklik)' },
  { value: 'yearly', label: 'Yılda Bir (Yıllık)' }
];

export const formatTaskPeriod = (value) => {
  const period = COMPANY_TASK_PERIODS.find((p) => p.value === value);
  return period ? period.label : 'Her Ay';
};
